define('controllers/admin/customercontacts',['require','johngrid'],function (require) {
    var CreateJohnGrid = require('johngrid');
    return function() {
        var columns = [
                            { DataField: "Name" },
                            { DataField: "EMailAddress", HeaderText: "Email" },
                            { DataField: "PhoneMain", HeaderText: "Phone Main" },
                            { DataField: "PhoneMobile", HeaderText: "Phone Mobile" },
                            { DataField: "PhoneFax", HeaderText: "Fax" },
                            { DataField: "AKA" },
                            { DataField: "Title" },
                            { DataField: "MailingAddress", HeaderText: "Address" },
                            { DataField: "City" },
                            { DataField: "StateProv", HeaderText: "State" },
                            { DataField: "PostalCode", HeaderText: "Postal" },
                            { DataField: "Note" },
                            { DataField: "NoteInternal", HeaderText: "Note Internal" },
                            { DataField: "Created" }
        ],
                datasource = "contactsAJAX.aspx",
                table = $("#tblCustomerContacts"),
                grid = CreateJohnGrid(),
                saveTemplate = $("#editForm");

        grid.insertHelpers.init(saveTemplate);
        grid.editHelpers.init(saveTemplate);
        grid.utilities.validateItem = function (contact) {
            var errors = [];

            if (contact.Name.trim() == "") {
                errors.push("Please enter a name.");
            }

            contact.CustomerID = custId;
            return errors;
        };
        grid.deleteHelpers.allowDelete = true;

        grid.init(table, columns, datasource);
        var custId = requestQueryString("cid");
        grid.dsPostValues.CustomerID = custId;
        grid.databind();
    };
});

